import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Util } from '../util';
import { ActionType } from '../models/action';
import { LoginDialogComponent } from '../login/components/login-dialog/login-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class InterestedUserService {
  constructor(private dialog: MatDialog) {}

  openSingUpModal(openModal: boolean) {
    if (openModal) {
      setTimeout(() => {
        this.dialog
          .open(LoginDialogComponent, {
            data: {
              showRegisterForm: true,
            },
          })
          .afterClosed()
          .subscribe((result) => {
            if (result) {
              (window as any).location.reload();
            } else {
              const action = Util.getAction();
              if (action) {
                Util.setAction({
                  ...action,
                  type: ActionType.NONE,
                });
              } else {
                Util.removeAction();
              }
            }
          });
      }, 100);
    }
  }
}
